package io.horion.cv.di

import io.horion.cv.api.usecase.CvUseCase
import io.horion.cv.api.usecase.JobUseCase
import io.horion.cv.api.usecase.PayUseCase
import org.koin.dsl.module

val useCaseModule = module {
    single { CvUseCase(get(),get()) }
    single { JobUseCase(get()) }
    single { PayUseCase(get()) }
}